import * as companyOrderDocumentActions from './companyOrderDocumentActions';
import * as companyOrderDocumentTypes from './companyOrderDocumentTypes';
import sagas from './companyOrderDocumentSagas';

import sagaManager from '../sagaManager';

sagaManager.addSagaToRoot(sagas);

export { companyOrderDocumentActions, companyOrderDocumentTypes };
